import styled, { css } from 'styled-components'
import noop from 'lodash/noop'
import { colors } from '@/styles'
import { getImageUrl } from '@/utils/image'
import camera from './camera.png'

const MIN_GRID = 1
const MAX_GRID = 5

const ImageGrid = styled.button`
  user-select: none;
  position: relative;
  height: 100%;
  width: 100%;
  border: none;
  cursor: pointer;
`

const singleImage = css`
  > ${ImageGrid}:first-of-type {
    background: ${colors.background};
    object-fit: contain;
    box-shadow: #f0f0f0 0px 0px 0px 1px;
  }
  clip-path: inset(-2px -2px -15px -2px round 10px);
  overflow: visible;
`

const topSpan = css`
  > ${ImageGrid}:nth-of-type(2) {
    grid-column: 2 span;
  }
`

const bottomSpan = css`
  > ${ImageGrid}:last-of-type {
    grid-column: 2 span;
  }
`

const rightSpan = css`
  > ${ImageGrid}:last-of-type {
    grid-row: 2 span;
    grid-column: 2 span;
  }
`

const MaxWidth = styled.div`
  margin: 0 auto;
  display: flex;
  max-width: 1280px;
  justify-content: center;
  @media only screen and (max-width: 1025px) {
    max-width: 820px;
  }
`

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  border-radius: 10px;
  display: grid;
  margin: 15px 35px 20px;

  grid-gap: 12px;
  grid-template-columns: repeat(4, 0.25fr);
  grid-template-rows: repeat(2, 295px);

  height: 590px;
  overflow: hidden;
  @media only screen and (max-width: 1025px) {
    grid-template-rows: repeat(2, 217.5px);
    height: 435px;
  }
  @media only screen and (max-width: 599px) {
    grid-template-rows: repeat(2, 180px);
    height: 360px;
  }

  > ${ImageGrid}:first-of-type {
    grid-row: 2 span;
    grid-column: ${props => (props.$count > MIN_GRID ? 2 : 4)} span;
  }

  ${props => props.$count === 2 && rightSpan};
  ${props => props.$count === 3 && bottomSpan};
  ${props => (props.$count === 3 || props.$count === 4) && topSpan};

  ${props => props.$count === 1 && singleImage};
`

const Count = styled.div`
  pointer-events: none;
  position: absolute;
  top: 17px;
  left: 17px;
  height: 33px;
  color: ${colors.mediumLightGrey};
  background: rgba(0, 0, 0, 0.7);
  border-radius: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  z-index: 50;
`

const CameraWrapper = styled.div`
  position: relative;
  width: 25px;
  height: 25px;
  margin-right: 5px;
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  margin-left: 5px;
`

const ImageWrap = styled.span`
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  width: initial;
  height: initial;
  background: none;
  opacity: 1;
  border: 0px;
  margin: 0px;
  padding: 0px;
  position: absolute;
  inset: 0px;
`

const ListingImage = styled.img`
  position: absolute;
  inset: 0px;
  box-sizing: border-box;
  padding: 0px;
  border: none;
  margin: auto;
  display: block;
  width: 0px;
  height: 0px;
  min-width: 100%;
  max-width: 100%;
  min-height: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center center;
`

const PhotoGrid = ({ images, openImage = noop }) => {
  const count = images?.length || 0
  const display = images.slice(0, Math.min(count, MAX_GRID))

  return (
    <MaxWidth>
      <Wrapper $count={count}>
        <Count>
          <CameraWrapper>
            <img src={camera} width={26} height={26} alt="" />
          </CameraWrapper>
          <Text>{count}</Text>
        </Count>
        {display.map((image, index) => (
          <ImageGrid tabIndex="-1" key={`photo-grid-${index}`} onClick={() => openImage(index)}>
            <ImageWrap>
              <ListingImage
                src={getImageUrl(image, {
                  fit: 'fit-in/735x500',
                  quality: 100
                })}
                alt=""
              />
            </ImageWrap>
          </ImageGrid>
        ))}
      </Wrapper>
    </MaxWidth>
  )
}

export default PhotoGrid
